
import { mapActions, mapGetters, mapMutations } from "vuex";
import offers from "@/apollo/queries/offer/offers";

const budgetSet = 'before-500'
const budgetFilter = { url: '/cars', price_to: 500000 }

export default {
	props: {
		samplingCars: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			set: '',
			hasBudgetOffers: false,

			sampling__cars: [
				{
					title: "Топ-предложения",
					slug: 'best'
				},
				{
					title: "Свежие",
					slug: 'fresh'
				},
				{
					title: "До 500 000 ₽",
					slug: budgetSet
				},
				// {
				// 	title: "Топ-выгода",
				// 	slug: 'test',
				// },
				{
					title: "7-местные",
					slug: 'seats-7'
				},
				{
					title: "До 2 владельцев",
					slug: 'owners-2'
				},
				{
					title: "До 5 лет",
					slug: 'young'
				},
				{
					title: "Седаны",
					slug: 'sedan'
				},
				{
					title: "Премиум",
					slug: 'premium'
				}

			],
			showButtonCompilation: true
		}
	},
	computed: {
		...mapGetters({
			offers: 'catalog/catalog-cars/offers',
			loading: 'catalog/catalog-cars/loading'
		}),
		availableSamples() {
			return this.sampling__cars.filter(car => car.slug !== budgetSet || this.hasBudgetOffers)
		}
	},
	methods: {

		...mapActions({
			request: 'filters/filters/request',
			openModal: 'modal/modal-main/openModal',
		}),
		...mapMutations({
			setOffers: 'catalog/catalog-cars/SET_OFFERS',
			setLoading: 'catalog/catalog-cars/SET_LOADING'
		}),
		async checkBudgetOffers() {
			try {
				const { data } = await this.request({
					query: offers,
					variables: { ...budgetFilter, page: 1, limit: 1 }
				})
				this.hasBudgetOffers = Boolean(data?.offers?.data?.some(Boolean))
			} catch (error) {
				console.error('Не удалось проверить подборку до 500 000 ₽:', error)
			}
		},
		async getOffers(set) {
			this.setLoading(true)
			try {
				const { data } = await this.request({
					query: offers,
					variables: {
						...(set === budgetSet ? budgetFilter : { set }),
						page: 1,
						limit: 8,
						dateFormat: 'j F Y года.',
						sort: set === 'best' ? 'created_at|desc' : 'price|asc'
					}
				})
				const items = data?.offers?.data
				if (set === budgetSet && !items?.some(Boolean)) {
					this.hasBudgetOffers = false
					return
				}
				this.setOffers(data?.offers)
				this.set = set
			} catch (error) {
				if (set === budgetSet) this.hasBudgetOffers = false
				console.error('Не удалось загрузить подборку авто:', error)
			} finally {
				this.setLoading(false)
			}
		},
		tabClick(car) {
			if (this.loading) return
			this.getOffers(car.slug)
			const target_top = this.$refs.title.getBoundingClientRect().top
			if (this.$device.isMobile)
				window.scrollBy({
					top: target_top - 60,
					behavior: 'smooth'
				})

		},
		async filterRequest(assignVariables) {
			try {
				await this.setLoading(true)
				let response = await this.request({ query: offers, variables: assignVariables })

				await this.setLoading(false)
				this.setOffers(response.data.offers);

			} catch (error) {
				return this.$nuxt.error({ statusCode: 404, message: '404' })
			}
		},

		moreOffers() {
			this.filterRequest({
				url: '/cars',
				page: 1,
				dateFormat: 'j F Y года.',
				// year_from: Number(new Date().getFullYear()-4),
				// year_to: Number(new Date().getFullYear()),
				sort: 'year|desc',
				price_from: 0,
				// limit: this.$device.isMobile == true ? 3 : 9
				limit: 8

			})
		},
		openMenu() {
			let payload = {
				modal_component: 'modal-filter-mobile',
				modal_data: 'filter-mobile',
				modal_title: 'Фильтр',
				modal_sub_title: ''
			}
			this.openModal(payload);
			this.$router.push('/cars');
		}
	},
	mounted() {
		this.moreOffers();
		if (this.samplingCars) this.checkBudgetOffers()
	},


}
